import { scheduleFormDataName, DEFAULT_DATE_PICKER_CLASSNAME } from './constants'

import type { ScheduleFormDataConfig } from './types'

export const formDataConfigs: ScheduleFormDataConfig[] = [
  {
    label: 'Дата старта',
    name: scheduleFormDataName.MONITORING_START_AT_DATETIME,
    className: DEFAULT_DATE_PICKER_CLASSNAME,
    defaultValue: null
  },
  {
    label: 'Дата получения данных',
    name: scheduleFormDataName.RECEIVING_DATA_DEADLINE_DATETIME,
    className: DEFAULT_DATE_PICKER_CLASSNAME,
    defaultValue: null
  },
  {
    label: 'Дата обработки данных',
    name: scheduleFormDataName.PROCESSING_DATA_DEADLINE_DATETIME,
    className: DEFAULT_DATE_PICKER_CLASSNAME,
    defaultValue: null
  },
  {
    label: 'Дата выставления новой цены',
    name: scheduleFormDataName.NEW_DATA_DEADLINE_DATETIME,
    className: DEFAULT_DATE_PICKER_CLASSNAME,
    defaultValue: null
  }
]
